import React from "react";
import PropTypes from "prop-types";
import { staticCdnUrl } from "../../../constants/url-constants";

const logoMap = {
    blue: `${staticCdnUrl()}/prod/cms/2026/01/22/244d7828-5929-4f98-a068-7b2113c83339blue-brand-logo.svg`,
    black: `${staticCdnUrl()}/prod/cms/2026/01/22/e5285751-b60e-49b4-90c5-2dc481e4510dblack-brand-logo.svg`,
    white: `${staticCdnUrl()}/prod/cms/2026/01/22/42845d72-8a55-4114-95bd-fab3231a3a86white-brand-logo.svg`
};

const Logo = ({ width = "80", height = "39", isWhiteLogo = false, type = "blue" }) => {
    return (
        <img
            width={width}
            height={height}
            style={{width, height}}
            src={logoMap[isWhiteLogo ? "white" : type] || logoMap.blue}
            alt="Cars24"
        />
    );
};

Logo.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    isWhiteLogo: PropTypes.bool,
    type: PropTypes.string
};

export default Logo;
